import { Loader2, Search } from "lucide-react";
import type UserSetting from "../models/UserSetting";
import { UserSettingRow } from "./user_setting_row";

interface UserSettingsTableProps {
  settings: UserSetting[];
  loading: boolean;
  error: Error | null;
  onGet: (key: number) => Promise<string>;
  onSet: (key: number, newValue: string) => Promise<void>;
}

export function UserSettingsTable({
  settings,
  loading,
  error,
  onGet,
  onSet,
}: UserSettingsTableProps) {
  return (
    <div className="bg-white/60 backdrop-blur-sm border border-black/5 rounded-2xl shadow-sm overflow-hidden mb-8">
      {/* Table Header */}
      <div className="grid grid-cols-[2fr_1fr_3fr_auto] gap-4 px-6 py-4 bg-black/3 border-b border-black/5 text-xs font-bold text-foreground/40 uppercase tracking-widest">
        <span>Clave</span>
        <span>Tipo</span>
        <span>Valor</span>
        <span />
      </div>

      {loading && (
        <div className="flex justify-center py-16">
          <Loader2 className="size-8 animate-spin text-accent" />
        </div>
      )}

      {error && (
        <div className="text-center py-16 text-red-500">
          <p>Error al cargar la configuración: {error.message}</p>
        </div>
      )}

      {!loading && !error && settings.length === 0 && (
        <div className="flex flex-col items-center justify-center py-20 text-foreground/20">
          <Search className="size-10 mb-3 opacity-30" />
          <p className="text-sm font-medium">No hay claves registradas</p>
        </div>
      )}

      {!loading &&
        !error &&
        settings.map((s, i) => (
          <UserSettingRow
            key={s.key}
            setting={s}
            isLast={i === settings.length - 1}
            onGet={onGet}
            onSet={onSet}
          />
        ))}
    </div>
  );
}
